import React, { useEffect, useState } from 'react';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import '../Component-Library.scss';
import { IMAGE_LARGE } from '../../../../constants/UiBuilderConst';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

const LargeImageComponent = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;

  const initialState = {
    imgURL: null,
    videoURL: null,
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    loopPlayBack: false,
    isVideo: false,
    shadowOverlay: false,
  };

  const [configState, setConfigState] = useState(
    config.imgURL || config.videoURL ? config : initialState,
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    onItemChange({
      componentName: IMAGE_LARGE,
      config: configState,
    });
  }, [configState]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === IMAGE_LARGE,
      );
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      if (val) return '';
      return 'required';
    } else {
      if (val.type && val.value) return '';
      return 'required';
    }
  };

  const handleTabData = (val, slideContent, field) => {
    if (error) {
      const currError = { ...error };
      const currConfigError = {
        ...currError.config,
        [field]: setErrorField(field, val),
      };
      currError.config = currConfigError;
      setError(currError);
    }
    const tempConfigState = { ...configState };
    switch (field) {
      case 'imgURL':
        tempConfigState.imgURL = val;
        break;
      case 'redirect':
        tempConfigState.redirectLink.connection = val.type;
        tempConfigState.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        tempConfigState.redirectLink.isActive = val;
        break;
      case 'shadowOverlay':
        tempConfigState.shadowOverlay = val;
        break;
      case 'isVideo':
        tempConfigState.isVideo = val;
        break;
      case 'videoURL':
        tempConfigState.videoURL = val;
        break;
      case 'loopPlayBack':
        tempConfigState.loopPlayBack = val;
        break;
      default:
        break;
    }
    setConfigState(tempConfigState);
  };

  const hasError = (key) => {
    if (key === 'imgURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && error?.config[key] === 'required') {
      return true;
    } else if (key === 'videoURL' && error?.config[key] === 'validUrl') {
      return 'validUrl';
    }
    return false;
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-12'>
        <div className='row mt-3 mb-3'>
          <div className='col-md-12 pe-5'>
            <div className='col-md-12'>
              <div className='col-md-10'>
                <MediaSelector
                  groupId={groupId}
                  titleH2={'Image'}
                  height={780}
                  width={1170}
                  handleTabData={handleTabData}
                  activeTabContent={configState}
                  isSwapEnabled={false}
                  hasError={hasError}
                  ratio={'3:2'}
                  matrix={'px - Full Bleed BG'}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <RedirectSelector
                  onValueChange={(e) => handleTabData(e, configState, 'redirect')}
                  redirectType={configState.redirectLink.connection}
                  value={configState.redirectLink.linkId}
                  onRedirectChange={(e) => {
                    handleTabData(e, configState, 'isActive');
                  }}
                  isActive={configState.redirectLink.isActive}
                  error={error?.config?.redirect === 'required' ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LargeImageComponent;
